import { VITE_APP_VERSION } from "../ENV.ts";

export const getAppVersion = () => {
  const version = VITE_APP_VERSION || "...";

  return `Версия ${version} (web)`;
};
